/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum WarningsEnum {
    WARNING = 'WARNING',
    ERROR = 'ERROR',
    INFO = 'INFO',
    WARNING_SEND = 'WARNING_SEND',
    WARNING_SAVE = 'WARNING_SAVE',
    WARNING_CREATE = 'WARNING_CREATE',
    WARNING_APPLY = 'WARNING_APPLY',
    WARNING_PNC_SEND = 'WARNING_PNC_SEND',
    WARNING_CUSTOM = 'WARNING_CUSTOM',
}
